import PetInsuranceData from "./PetInsuranceData"

export default function() {
    return PetInsuranceData({
        slug: 'kattforsakring-anpassa',
        extraFields: {
            veterinary_care_deductible: '0_50',
        },
    });
}
